import React, { Component } from 'react';

// eslint-disable-next-line import/no-named-as-default
import ShareReferral from '../../components/modal/ShareReferral';

class ShareReferralDialog extends Component {
  render() {
    return (
      <div>
        {/* eslint-disable react/jsx-props-no-spreading */}
        <ShareReferral
          {...this.props}
        />
        {/* eslint-enable react/jsx-props-no-spreading */}
      </div>
    );
  }
}

export default ShareReferralDialog;
